// services/childcare/helpdesk.js
import { api } from "./utils";

// Get all FAQs
export const getFAQs = async () => {
  try {
    const response = await api.get("/childcare/helpdesk/faqs");
    return response;
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    throw error;
  }
};

// Get contact information
export const getContactInfo = async () => {
  try {
    const response = await api.get("/childcare/helpdesk/contact");
    return response;
  } catch (error) {
    console.error("Error fetching contact info:", error);
    throw error;
  }
};

// Get support tickets
export const getSupportTickets = async () => {
  try {
    const response = await api.get("/childcare/helpdesk/tickets");
    return response;
  } catch (error) {
    console.error("Error fetching support tickets:", error);
    throw error;
  }
};

// Get single ticket with replies
export const getTicketDetail = async (ticketId) => {
  try {
    const response = await api.get(`/childcare/helpdesk/tickets/${ticketId}`);
    return response;
  } catch (error) {
    console.error("Error fetching ticket detail:", error);
    throw error;
  }
};

// Reply to a ticket
export const addTicketReply = async (ticketId, reply) => {
  try {
    const response = await api.post(`/childcare/helpdesk/tickets/${ticketId}/reply`, { reply });
    return response;
  } catch (error) {
    console.error("Error sending reply:", error);
    throw error;
  }
};

// Create support ticket
export const createSupportTicket = async (ticketData) => {
  try {
    const response = await api.post("/childcare/helpdesk/tickets", ticketData);
    return response;
  } catch (error) {
    console.error("Error creating support ticket:", error);
    throw error;
  }
};
